import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
import { debounce } from '../js/debounce';
export const stickyHeaderMobile = () => {
    const headerWrapper = document.querySelector('.site-header');
    if (isNullOrUndef(headerWrapper))
        return;
    const header = headerWrapper.querySelector('.site-header--new');
    let headerShowed = false;
    const threshold = 100;
    let oldScroll = 0;
    let distance = 0;
    if (isNullOrUndef(header))
        return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                header.style.transform = 'translateY(-100%)';
                document.documentElement.style.setProperty('--sticky-header-height', `${header.clientHeight}px`);
                document.documentElement.style.setProperty('--sticky-header-start-height', `${header.clientHeight}px`);
                header.classList.add('header-sticky');
                header.style.transform = '';
            }
            else if (entry.intersectionRatio === 1) {
                document.documentElement.style.setProperty('--sticky-header-height', '0');
                document.documentElement.style.setProperty('--sticky-header-start-height', '0');
                header.classList.remove('header-sticky');
            }
        });
    }, {
        threshold: [0.0, 1.0]
    });
    observer.observe(headerWrapper);
    const debouncedClearDistance = debounce(() => {
        distance = 0;
    }, 300);
    const checkScroll = () => {
        const currentScroll = window.scrollY;
        if (oldScroll > currentScroll) {
            if (!headerShowed) {
                distance += oldScroll - currentScroll;
                if (distance > threshold) {
                    document.documentElement.style.setProperty('--sticky-header-viewed-height', 'var(--sticky-header-height)');
                    header.classList.add('header-sticky--show');
                    headerShowed = true;
                    distance = 0;
                }
            }
            else {
                distance = 0;
            }
        }
        else {
            if (headerShowed) {
                distance += currentScroll - oldScroll;
                if (distance > threshold) {
                    document.documentElement.style.setProperty('--sticky-header-viewed-height', '0');
                    header.classList.remove('header-sticky--show');
                    headerShowed = false;
                    distance = 0;
                }
            }
            else {
                distance = 0;
            }
        }
        oldScroll = currentScroll;
        debouncedClearDistance();
    };
    checkScroll();
    document.addEventListener('scroll', () => { checkScroll(); });
};
